export default {
	message: state => state.message,
	payments: state => state.payments,
	loading: state => state.loading,
	loadingSave: state => state.loadingSave,
	paymentsType: state => {
		const typePayment = state.payments;
		for (const element of typePayment) {
			if (element.paymentType == 'lodging') element.paymentType = 'Pago por alojamiento';
			if (element.paymentType == 'byDates') element.paymentType = 'Pago por fecha';
		}
		return typePayment;
	},
	paymentsForMonth: state => {
		const paymentsMonth = state.payments;
		const arrayMonth = paymentsMonth.map(payment => payment.startDate.slice(0, 7));
		const removeDuplicates = [...new Set(arrayMonth)];
		return removeDuplicates;
	},
	groupPayments: state => {
		const initialValue = {};
		const paymentsMonth = state.payments;
		const paymentsByGroupMonth = arrayPayments => {
			return Object.values(
				arrayPayments.reduce((result, value) => {
					const sliceMonth = value.startDate.slice(0, 7);
					if (!result[sliceMonth]) {
						result[sliceMonth] = [];
					}
					result[sliceMonth].push(value);
					return result;
				}, initialValue)
			);
		};
		return paymentsByGroupMonth(paymentsMonth);
	},
};
